// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Packages index (Stitch Clinical Precision) ——— */
.pkg-screen {
  box-sizing: border-box;
  padding: 24px;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pkg-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid #F1F5F9;
}

.pkg-heading__left {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pkg-heading__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.pkg-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pkg-title-row h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.pkg-count {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  border: 1px solid #E2E8F0;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  background: #F1F5F9;
  color: #475569;
}

.pkg-subtitle {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: #64748B;
}

.pkg-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.pkg-btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.pkg-btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.pkg-btn--primary .anticon {
  font-size: 14px;
}

.pkg-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pkg-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 280px;
  min-width: 200px;
  max-width: 320px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.pkg-search:focus-within {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.pkg-search__icon {
  flex-shrink: 0;
  color: #94A3B8;
  font-size: 16px;
  margin-inline-end: 8px;
}

.pkg-search__input.ant-input-affix-wrapper,
.pkg-search__input.ant-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 34px !important;
  padding: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 12px;
}

.pkg-search__input.ant-input-affix-wrapper .ant-input {
  font-size: 12px;
}

.pkg-element-filters {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

.pkg-chip {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 9999px;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.pkg-chip:hover {
  background: #F8FAFC;
}

.pkg-chip.is-active {
  border-color: #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-weight: 600;
}

.pkg-table-card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
}

.pkg-list {
  height: auto;
  min-height: 120px;
  min-width: 0;
}

.pkg-table-scroll {
  width: 100%;
  overflow-x: auto;
  min-width: 0;
}

.pkg-table {
  --pkg-cols: 56px minmax(0, 2fr) minmax(0, 1.1fr) minmax(0, 1.3fr) 120px 76px;
  display: grid;
  grid-template-columns: var(--pkg-cols);
  width: 100%;
  min-width: 920px;
  font-size: 12px;
  background: #ffffff;
}

.pkg-table.no-action {
  --pkg-cols: 56px minmax(0, 2fr) minmax(0, 1.1fr) minmax(0, 1.3fr) 120px;
  min-width: 840px;
}

.pkg-table.is-fetching {
  opacity: 0.72;
}

.pkg-table__head,
.pkg-table__row {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: stretch;
  margin: 0;
  padding: 0;
  border-radius: 0;
  box-sizing: border-box;
}

.pkg-table__head {
  border-bottom: 1px solid #E2E8F0;
}

.pkg-table__head .pkg-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 32px;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
  text-align: start;
  background: #F8FAFC !important;
  border: 0 !important;
  border-radius: 0 !important;
}

.pkg-table__row {
  cursor: pointer;
  border-bottom: 1px solid #F1F5F9;
}

.pkg-table__row:last-child {
  border-bottom: 0;
}

.pkg-table__row .pkg-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 56px;
  padding: 10px 12px;
  color: #334155;
  min-width: 0;
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 0 !important;
  transition: background 0.12s ease;
}

.pkg-table__row:hover .pkg-cell {
  background: #F8FAFC !important;
}

.pkg-table__row .pkg-cell.is-name {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
}

.pkg-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #64748B;
}

.pkg-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

.pkg-name {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.pkg-table__row:hover .pkg-name {
  color: #0284C7;
}

.pkg-code {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
  color: #475569;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.pkg-desc {
  margin: 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.pkg-element-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
}

.pkg-element-entity {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
}

.pkg-element {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.pkg-element__icon {
  color: #64748B;
  font-size: 14px;
  display: inline-flex;
}

.pkg-tiers {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pkg-tiers__count {
  font-size: 12px;
  font-weight: 500;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

.pkg-tiers__range {
  display: inline-block;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  color: #64748B;
  font-variant-numeric: tabular-nums;
  unicode-bidi: isolate;
  direction: ltr;
  text-align: start;
}

.pkg-tiers__amount {
  unicode-bidi: isolate;
}

.pkg-tiers__sep {
  unicode-bidi: isolate;
}

[dir='rtl'] .pkg-tiers {
  align-items: flex-start;
}

.pkg-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 9999px;
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.4;
}

.pkg-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.pkg-status.is-enabled {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.pkg-status.is-enabled .pkg-status__dot {
  background: #10B981;
}

.pkg-status.is-disabled {
  background: #F8FAFC;
  color: #64748B;
  border-color: #E2E8F0;
}

.pkg-status.is-disabled .pkg-status__dot {
  background: #94A3B8;
}

.pkg-row-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.pkg-row-link:hover {
  color: #0284C7;
}

[dir='rtl'] .pkg-row-link .anticon {
  transform: scaleX(-1);
}

.pkg-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 16px;
  color: #94A3B8;
  font-size: 13px;
}

.pkg-empty p {
  margin: 0;
}

.pkg-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #F1F5F9;
  background: #ffffff;
}

.pkg-pager__meta {
  font-size: 12px;
  color: #64748B;
}

.pkg-pager__controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pkg-pager__btn {
  box-sizing: border-box;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.pkg-pager__btn:hover:not(:disabled) {
  background: #F8FAFC;
}

.pkg-pager__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pkg-pager__page {
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  font-variant-numeric: tabular-nums;
  min-width: 64px;
  text-align: center;
}

@media (max-width: 768px) {
  .pkg-screen {
    padding: 16px;
  }

  .pkg-title-row h1 {
    font-size: 20px;
  }

  .pkg-search {
    flex: 1 1 100%;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Packages/style.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,4EAA4E;EAC5E,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;EACvE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,6EAA6E;EAC7E,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":["/* ——— Packages index (Stitch Clinical Precision) ——— */\n.pkg-screen {\n  box-sizing: border-box;\n  padding: 24px;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pkg-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.pkg-heading__left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.pkg-heading__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.pkg-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.pkg-title-row h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.pkg-count {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  border: 1px solid #E2E8F0;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  background: #F1F5F9;\n  color: #475569;\n}\n\n.pkg-subtitle {\n  margin: 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748B;\n}\n\n.pkg-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.pkg-btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.pkg-btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.pkg-btn--primary .anticon {\n  font-size: 14px;\n}\n\n.pkg-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.pkg-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 0 1 280px;\n  min-width: 200px;\n  max-width: 320px;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.pkg-search:focus-within {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.pkg-search__icon {\n  flex-shrink: 0;\n  color: #94A3B8;\n  font-size: 16px;\n  margin-inline-end: 8px;\n}\n\n.pkg-search__input.ant-input-affix-wrapper,\n.pkg-search__input.ant-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 34px !important;\n  padding: 0 !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 12px;\n}\n\n.pkg-search__input.ant-input-affix-wrapper .ant-input {\n  font-size: 12px;\n}\n\n.pkg-element-filters {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.pkg-chip {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 9999px;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.pkg-chip:hover {\n  background: #F8FAFC;\n}\n\n.pkg-chip.is-active {\n  border-color: #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-weight: 600;\n}\n\n.pkg-table-card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  overflow: hidden;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.pkg-list {\n  height: auto;\n  min-height: 120px;\n  min-width: 0;\n}\n\n.pkg-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  min-width: 0;\n}\n\n.pkg-table {\n  --pkg-cols: 56px minmax(0, 2fr) minmax(0, 1.1fr) minmax(0, 1.3fr) 120px 76px;\n  display: grid;\n  grid-template-columns: var(--pkg-cols);\n  width: 100%;\n  min-width: 920px;\n  font-size: 12px;\n  background: #ffffff;\n}\n\n.pkg-table.no-action {\n  --pkg-cols: 56px minmax(0, 2fr) minmax(0, 1.1fr) minmax(0, 1.3fr) 120px;\n  min-width: 840px;\n}\n\n.pkg-table.is-fetching {\n  opacity: 0.72;\n}\n\n.pkg-table__head,\n.pkg-table__row {\n  display: grid;\n  grid-template-columns: subgrid;\n  grid-column: 1 / -1;\n  align-items: stretch;\n  margin: 0;\n  padding: 0;\n  border-radius: 0;\n  box-sizing: border-box;\n}\n\n.pkg-table__head {\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.pkg-table__head .pkg-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 32px;\n  padding: 6px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n  text-align: start;\n  background: #F8FAFC !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n}\n\n.pkg-table__row {\n  cursor: pointer;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.pkg-table__row:last-child {\n  border-bottom: 0;\n}\n\n.pkg-table__row .pkg-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 56px;\n  padding: 10px 12px;\n  color: #334155;\n  min-width: 0;\n  background: #ffffff !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  transition: background 0.12s ease;\n}\n\n.pkg-table__row:hover .pkg-cell {\n  background: #F8FAFC !important;\n}\n\n.pkg-table__row .pkg-cell.is-name {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 2px;\n}\n\n.pkg-id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 13px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #64748B;\n}\n\n.pkg-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.pkg-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.pkg-table__row:hover .pkg-name {\n  color: #0284C7;\n}\n\n.pkg-code {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid #E2E8F0;\n  background: #F1F5F9;\n  color: #475569;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.pkg-desc {\n  margin: 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.pkg-element-stack {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  min-width: 0;\n}\n\n.pkg-element-entity {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pkg-element {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #F1F5F9;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.pkg-element__icon {\n  color: #64748B;\n  font-size: 14px;\n  display: inline-flex;\n}\n\n.pkg-tiers {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.pkg-tiers__count {\n  font-size: 12px;\n  font-weight: 500;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n}\n\n.pkg-tiers__range {\n  display: inline-block;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n  unicode-bidi: isolate;\n  direction: ltr;\n  text-align: start;\n}\n\n.pkg-tiers__amount {\n  unicode-bidi: isolate;\n}\n\n.pkg-tiers__sep {\n  unicode-bidi: isolate;\n}\n\n[dir='rtl'] .pkg-tiers {\n  align-items: flex-start;\n}\n\n.pkg-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.pkg-status__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.pkg-status.is-enabled {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.pkg-status.is-enabled .pkg-status__dot {\n  background: #10B981;\n}\n\n.pkg-status.is-disabled {\n  background: #F8FAFC;\n  color: #64748B;\n  border-color: #E2E8F0;\n}\n\n.pkg-status.is-disabled .pkg-status__dot {\n  background: #94A3B8;\n}\n\n.pkg-row-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.pkg-row-link:hover {\n  color: #0284C7;\n}\n\n[dir='rtl'] .pkg-row-link .anticon {\n  transform: scaleX(-1);\n}\n\n.pkg-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 48px 16px;\n  color: #94A3B8;\n  font-size: 13px;\n}\n\n.pkg-empty p {\n  margin: 0;\n}\n\n.pkg-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-top: 1px solid #F1F5F9;\n  background: #ffffff;\n}\n\n.pkg-pager__meta {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pkg-pager__controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pkg-pager__btn {\n  box-sizing: border-box;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.pkg-pager__btn:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.pkg-pager__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pkg-pager__page {\n  font-size: 12px;\n  font-weight: 500;\n  color: #475569;\n  font-variant-numeric: tabular-nums;\n  min-width: 64px;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .pkg-screen {\n    padding: 16px;\n  }\n\n  .pkg-title-row h1 {\n    font-size: 20px;\n  }\n\n  .pkg-search {\n    flex: 1 1 100%;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
